import { render, staticRenderFns } from "./CoachManagerConversion.vue?vue&type=template&id=12b54c08"
import script from "./CoachManagerConversion.vue?vue&type=script&lang=js"
export * from "./CoachManagerConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports